import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';
import { LoggingService } from '../../services/logging-service/logging.service';
import { pipe } from 'rxjs/util/pipe';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { UsefulWebsite } from '../../models/useful-website';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-portal-useful-website-view',
  templateUrl: './portal-useful-website-view.component.html',
  styleUrls: ['./portal-useful-website-view.component.css']
})
export class PortalUsefulWebsiteViewComponent implements OnInit {

  usefulWebsites: UsefulWebsite[] = [];
  error = false;
  addNew = false;
  addNewSite: UsefulWebsite;


  constructor(private shellUpdateService: ShellUpdateService, private appConfigService: AppConfigService,
    private userSession: UserSessionService, private router: Router, private trustService: TrustDataService,
    private loggingService: LoggingService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, 'Useful Websites', null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, false, true));

    // Get all of the data for the useful websites
    this.trustService.getUsefulWebsites()
      .pipe(map(sites => sites.json()))
      .subscribe(sites => {
        this.loggingService.log('Executed getUsefulWebsites', this.appConfigService.LogToConsole);
        this.usefulWebsites = sites;
      }, (error: HttpErrorResponse) => {
        this.handleError(error);
      });
  }

  // ** Updates a useful website by using the associated object */
  update(usefulWebsite: UsefulWebsite) {
    if (usefulWebsite.UrlId > 0) {
      this.trustService.updateUsefulWebsite(usefulWebsite).subscribe(response => {
        this.snackBar.open('Useful Website Updated Successfully', null, { duration: 3000 });
      }, (error => {
        this.handleError(error);
      }));
    }

    if (usefulWebsite.UrlId === undefined) {
      this.trustService.addUsefulWebsite(usefulWebsite).subscribe(response => {
        this.usefulWebsites.push(response.json());
        this.addNew = false;
        this.snackBar.open('Useful Website Added Successfully', null, { duration: 3000 });
      }, (error => {
        this.handleError(error);
      }));
    }
  }

  // ** Deletes an existing schedule by using the associated object */
  delete(usefulWebsite: UsefulWebsite) {
    this.trustService.deleteUsefulWebsite(usefulWebsite).subscribe(response => {
      const removeSite = this.usefulWebsites.indexOf(usefulWebsite);
      this.usefulWebsites.splice(removeSite, 1);
      this.snackBar.open('Useful Website Deleted Successfully', null, { duration: 3000 });
    }, (error => {
      this.handleError(error);
    }));
  }

  cancel() {
    this.addNew = false;
  }

  /** Creates a new schedule by creating an instance of the new form */
  createSite() {
    // Show the editor by setting add new to true
    // When this panel is clicked use the add new method by checking if the id  == 0
    // Else use the update method
    this.addNew = true;
    this.addNewSite = new UsefulWebsite();
  }

  // ** Handle anything that has gone wrong during submission */
  handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. You appear to be offline.', '', { duration: 5000 });
        this.loggingService.log('Error - offline', this.appConfigService.LogToConsole);
        break;
      case 401:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. Your login has expired.', '', { duration: 5000 });
        this.loggingService.log('Error - login expired', this.appConfigService.LogToConsole);
        this.userSession.logout();
        break;
      case 500:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. Server error.', '', { duration: 5000 });
        this.loggingService.log('Error - Server error', this.appConfigService.LogToConsole);
        break;
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/portal-useful-website-view/portal-useful-website-view.component.ts